<template>
    <div class="flex-root-column replacements">
        <IsoCodeToLocationCodeDependenciesTable
            :columns="columns"
            @showMessage="showMessage"
        />
        <v-snackbar
            v-model="messageBox.show"
            :timeout="messageBox.closeTimeout"
            light
            class="coa_snack"
            :class="'coa_' + messageBox.type"
        >
            {{ messageBox.content }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    text
                    v-show="messageBox.closeTimeout === 0"
                    v-bind="attrs"
                    @click="messageBox.show = false"
                >
                    {{ messageBox.closeButtonText }}
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import IsoCodeToLocationCodeDependenciesTable from "../components/Dependencies/IsoCodeToLocationCodeDependenciesTable.vue";
import i18n from "../i18n";

export default {
    name: 'IsoCodeToLocationCodeDependencies',
    components: {IsoCodeToLocationCodeDependenciesTable},
    created() {
        this.$emit('updateHeaderNavigation', [{
            display: i18n.t('ISO > Location Code Dependencies')
        }]);
    },
    data() {
        return {
            messageBox: {
                show:            false,
                content:         '',
                closeButtonText: 'ok',
                closeTimeout:    -1,
            },
            columns: [
                {id: 'isoCodes',      title: 'ISO Codes',      visible: true, filter: 'data'},
                {id: 'locationCodes', title: 'Location Codes', visible: true, filter: 'data'},
            ],
        }
    },
    methods: {
        showMessage(content, type, close, buttonText) {
            this.messageBox.content = content;
            this.messageBox.type = type;
            this.messageBox.show = true;
            if (typeof close === 'number') {
                this.messageBox.closeTimeout = close;
            } else {
                this.messageBox.closeTimeout = -1;
            }
            if (buttonText) {
                this.messageBox.closeButtonText = buttonText;
            } else {
                this.messageBox.closeButtonText = 'ok';
            }
        }
    }
}
</script>